// NavItem.tsx
import { FC } from 'react';
import Link from 'next/link';
import * as styles from './styles';

type Props = {
  label: string;
  sublabel: string;
  path: string;
  isActive: boolean;
};

const NavItem: FC<Props> = ({ label, sublabel, path, isActive }) => (
  <li key={label} className={styles.isActiveNavItem(isActive)}>
    {isActive ? (
      <>
        {label}
        <span className={styles.navItemSublabel}>{sublabel}</span>
      </>
    ) : (
      <Link className="block" href={path}>
        {label}
        <span className={styles.navItemSublabel}>{sublabel}</span>
      </Link>
    )}
  </li>
);

export default NavItem;
